import { render } from 'storyblok-rich-text-react-renderer'

/**
 * render rich text from string
 */

export const getRichText = (string) => {
  return render(string)
}
